module.exports = __webpack_public_path__ + "static/gallery-12-9b90c299238fa7ed9e41b19462d2f006.jpg";